/*@ngInject*/
const UpdateAttachmentRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.updateAttachment = function (attachmentId, attachment) {
        let url = '/rest/UnderwritingAttachment/' + attachmentId;

        delete attachment.objectUri;
        delete attachment.size;

        return this.post(url, attachment);
    };
};

angular.module('umCore')
    .service('updateAttachmentRepository', UpdateAttachmentRepository);
